import { config } from 'config';
import { restClient } from 'modules/shared/services/API/backend';
import { Universe, Category } from '../../models';

export const universeService = {
    get: async (id: string) => {
        const response = await restClient.get<Universe>(`${config.backend.rest.catalogueUrl}/universe/${id}`);
        return response.data;
    },
    getCategories: async (id: string) => {
        const response = await restClient.get<Category[]>(
            `${config.backend.rest.catalogueUrl}/universe/${id}/categories}`,
        );
        return response.data;
    },
};
